import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Color } from '../../../../styles/Color';
import { RouterLink } from '../../link/RouterLink';
import { Css, ITheme, Responsive } from '../../../../ui';
import { FONT_FAMILY_MUSEO_SANS_CONDENSED } from '../../../../styles/Font';

export const Label = styled.span`
	transition: opacity 0.3s;
	font-weight: 500;
	font-size: ${Css.pxToRem(12)};
	font-family: ${FONT_FAMILY_MUSEO_SANS_CONDENSED};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-weight: 300;
		font-size: ${Css.pxToRem(14)};
	}
`;

export const navItemStyles = (theme: ITheme) => css`
	height: ${Css.pxToRem(40)};
	padding: ${Css.pxToRem(14)} ${Css.pxToRem(10)};
	display: flex;
	align-items: center;
	overflow: hidden;
	color: ${Color.Neutral6};
	text-decoration: none;
	width: 100%;
	white-space: nowrap;
	border: none;
	border-bottom: 2px solid transparent;
	border-top: 2px solid transparent;
	background-color: transparent;

	&:active {
		background: ${theme.color.brand};
		color: ${theme.color.onPrimary};
	}

	&[aria-current='page'],
	&[aria-current='true'] {
		background: ${theme.color.brand};
		color: ${theme.color.onPrimary};

		&:focus-visible {
			outline: 2px solid ${theme.color.secondary};
		}

		&:hover {
			color: ${theme.color.onPrimary};
		}
	}

	&:not([aria-current='page']):not([aria-current='true']):hover {
		border-bottom: 2px solid ${theme.color.brand};
	}

	&:focus-visible {
		outline: 2px solid ${theme.color.brand};
		outline-offset: -2px;
	}

	&:hover {
		color: ${Color.Neutral6};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		color: ${Color.OnBackground};
		padding: 0;
		height: auto;

		&[aria-current='page'],
		&[aria-current='true'] {
			background: none;
		}

		&:not([aria-current='page']):not([aria-current='true']):hover {
			border: none;
		}

		&:focus {
			outline: 2px solid transparent;
		}

		&:hover {
			background-color: transparent;
			color: ${theme.color.brand};
		}
	}
`;

export const StyledLink = styled(RouterLink)<{}, ITheme>`
	${(props) => navItemStyles(props.theme)}
`;

export const StyledButton = styled.button<{}, ITheme>`
	${(props) => navItemStyles(props.theme)}
`;
